// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._zulp12x7{gap:var(--ds-space-075,6px)}", ""]);
// Exports
module.exports = exports;
